<template>
  <ShopifyStock v-if="SHOPIFYBRANDS.includes(BRAND)"></ShopifyStock>
  <OpenCartStock v-else></OpenCartStock>
</template>

<script>
import { ShopifyStock, OpenCartStock } from "./partials";

export default {
  name: "stock",
  components: {
    ShopifyStock,
    OpenCartStock
  }
};
</script>
